import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateBefore',
  standalone: false,
})
export class TruncateBeforePipe implements PipeTransform {
  transform(value: string, delimiter: string, addEllipsis: boolean = true): string {
    if (!value) {
      return '';
    }

    if (!delimiter) {
      return value;
    }

    const index = value.indexOf(delimiter);

    if (index === -1) {
      return value;
    }

    const truncated = value.substring(0, index).trim();

    if (truncated === '') {
      return addEllipsis ? '...' : '';
    }

    if (addEllipsis === false) {
      return truncated;
    }

    return truncated + '...';
  }
}
